export default "__VITE_ASSET__wVurTs1M__"